export interface AccessDeniedError {
	message: string;
	severity: 'AccessDenied';
}

export const isAccessDenied = (res: unknown): res is AccessDeniedError => {
	return (res as AccessDeniedError).message !== undefined && (res as AccessDeniedError).severity === 'AccessDenied';
};
